













































  import { computed, defineComponent, ref, watch } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'OneBrandsList',
    setup() {
      const vm = useCurrentInstance()
      const highlightedBrandsTree = computed(() => vm.$store.state.brands.highlightedBrandsTree)
      const expandedBrands = ref<string[]>([])

      const routePathSegments = computed<string[]>(() => {
        const raw = (vm.$route?.path || '').replace(/^\/+|\/+$/g, '')
        if (!raw) { return [] }
        return raw.split('/').filter(Boolean).map(segment => {
          try { return decodeURIComponent(segment) } catch { return segment }
        })
      })

      const activeBrandName = computed<string | null>(() => routePathSegments.value[0] || null)
      const activeSeriesName = computed<string | null>(() => routePathSegments.value[1] || null)

      const findActiveBrand = () => {
        if (!activeBrandName.value) { return undefined }
        return highlightedBrandsTree.value.find(
          (item: any) => item.brand?.name === activeBrandName.value,
        )
      }

      const isBrandActive = (name: string): boolean => name === activeBrandName.value
      const isSeriesActive = (brandName: string, seriesName: string): boolean => {
        return brandName === activeBrandName.value && seriesName === activeSeriesName.value
      }

      const ensureActiveBrandExpanded = () => {
        const activeBrand = findActiveBrand()
        const brandId: string | undefined = activeBrand?.brand?.id
        if (brandId && !expandedBrands.value.includes(brandId)) {
          expandedBrands.value = [...expandedBrands.value, brandId]
        }
      }

      const fetchBrandsTree = async () => {
        try {
          if (!highlightedBrandsTree.value.length) {
            await vm.$store.dispatch('brands/fetchHighlightedBrandsTree')
          }
          ensureActiveBrandExpanded()
        } catch (error) {
          // @ts-ignore
          vm.$logger.error(error)
        }
      }

      const isSeriesVisible = (brandId: string): boolean => {
        return expandedBrands.value.includes(brandId)
      }

      const toggleSeries = (brandId: string): void => {
        if (expandedBrands.value.includes(brandId)) {
          expandedBrands.value = expandedBrands.value.filter(id => id !== brandId)
          return
        }
        expandedBrands.value = [...expandedBrands.value, brandId]
      }

      watch(activeBrandName, ensureActiveBrandExpanded)
      watch(highlightedBrandsTree, ensureActiveBrandExpanded)

      fetchBrandsTree()

      return {
        highlightedBrandsTree,
        isSeriesVisible,
        toggleSeries,
        isBrandActive,
        isSeriesActive,
      }
    },
  })
